import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-payments-layout',
  imports: [RouterOutlet, RouterLink],
  templateUrl: './payments-layout.component.html',
  styleUrl: './payments-layout.component.scss',
})
export class PaymentsLayoutComponent {}
